import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'utils/dayjs';

import { injectIntl } from 'react-intl';
import { getPreferenceTz } from 'utils/timezone';
import MessageBubble from 'components/global/chat/MessageBubble';
import DateWithLine from 'components/global/chat/DateWithLine';

function MessageList({ messages, timezone, intl }) {
  const prevLengthRef = useRef(messages.length);

  useEffect(() => {
    // When this component mounted, scroll to bottom of list
    const objDiv = document.getElementById('messages');
    objDiv.scrollTop = objDiv.scrollHeight;
  }, []);

  useEffect(() => {
    // There is a new message in the state, scroll to bottom of list
    if (messages.length > prevLengthRef.current) {
      const objDiv = document.getElementById('messages');
      objDiv.scrollTop = objDiv.scrollHeight;
    }
    prevLengthRef.current = messages.length;
  }, [messages.length]);

  return (
    <div id="messages" className="messages">
      {messages &&
        messages.map((singleMessage, index, originalArr) => {
          const key = singleMessage.id || singleMessage.timestamp || index;

          // Show a date separator above the first message of each day
          const firstOfDay =
            index === 0 ||
            (originalArr[Number(index) - 1] &&
              !dayjs
                .tz(singleMessage.timestamp, timezone)
                .isSame(
                  dayjs.tz(
                    originalArr[Number(index) - 1].timestamp,
                    timezone,
                  ),
                  'day',
                ));

          const bubble = (
            <MessageBubble
              variant="videoChat"
              fromMe={singleMessage.me === true}
              body={singleMessage.body}
              timestamp={dayjs(singleMessage.timestamp)
                .tz(timezone)
                .format('LT')}
              key={key}
            />
          );

          if (firstOfDay) {
            return (
              <div key={key}>
                <DateWithLine>
                  {intl.formatDate(singleMessage.timestamp, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: getPreferenceTz(),
                  })}
                </DateWithLine>
                {bubble}
              </div>
            );
          }
          return bubble;
        })}
    </div>
  );
}

MessageList.propTypes = {
  messages: PropTypes.array.isRequired,
  timezone: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(MessageList);
